RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Company = Marionette.ItemView.extend({
        template: '#commonCompanyTemplate',
        serializeData: function () {

            const me = this;
            let setupIcon = null;
            const model = me.model.toViewJSON();

            model.label = model.label || null;
            model.overview = '';

            if (!model.wasError) {

                const primaryDomainRecord = App.utils.companyDisplay.getPrimaryDomainRecord(model);

                if (primaryDomainRecord && primaryDomainRecord.presence) {

                    model.url = primaryDomainRecord.presence.source;
                }

                if (App.utils.companyDisplay.hasTwitter(model)) {

                    model.overview = App.utils.companyDisplay.getDescription(model);
                    setupIcon = function () {
                        me.$('.x-desc-icon-twitter').show();
                        App.utils.tooltip.addTooltip(me.$('.x-desc-icon-twitter'), {
                            title: 'Twitter Description'
                        });
                    };
                } else if (App.utils.companyDisplay.hasFacebook(model)) {

                    model.overview = App.utils.companyDisplay.getDescription(model);
                    setupIcon = function () {
                        me.$('.x-desc-icon-facebook').show();
                        App.utils.tooltip.addTooltip(me.$('.x-desc-icon-facebook'), {
                            title: 'Facebook Description'
                        });
                    };
                } else if (App.utils.companyDisplay.hasInstagram(model)) {

                    model.overview = App.utils.companyDisplay.getDescription(model);
                    setupIcon = function () {
                        me.$('.x-desc-icon-instagram').show();
                        App.utils.tooltip.addTooltip(me.$('.x-desc-icon-instagram'), {
                            title: 'Instagram Description'
                        });
                    };
                } else if (App.utils.companyDisplay.hasDomain(model)) {

                    model.overview = App.utils.companyDisplay.getDescription(model);
                    setupIcon = function () {
                        me.$('.x-desc-icon-globe').show();
                        App.utils.tooltip.addTooltip(me.$('.x-desc-icon-globe'), {
                            title: 'Description from Home Page'
                        });
                    };
                } else if (model.homepagetitle && !model.homepagetitle.match(/^\s*$/)) {

                    model.overview = model.homepagetitle;
                    setupIcon = function () {
                        me.$('.x-desc-icon-globe').show();
                        App.utils.tooltip.addTooltip(me.$('.x-desc-icon-globe'), {
                            title: 'Title from Home Page'
                        });
                    };
                } else {

                    model.overview = 'We found the web site you added, but we were unable to extract any overview information.';
                    setupIcon = function () {
                        me.$('.x-desc-icon-question').show();
                        App.utils.tooltip.addTooltip(me.$('.x-desc-icon-question'), {
                            title: 'No overview found'
                        });
                    };
                }
            }

            me.setupIcon = setupIcon;

            return model;
        },

        onRender: function () {
            const me = this;
            const setupIcon = me.setupIcon;
            const model = me.model.toViewJSON();

            me.$(`.x-desc-icon-${model.companyClass}`).show();

            if (model.wasError) {
                me.$('.x-company').hide();
                me.$('.x-error').show();
            } else if (setupIcon) {
                setupIcon();
            }

            return me;
        }
    });

});
